import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver} from '@/utils/baseUrl';
const api={
    payment:oaserver+'/payment',
    oacurrency:oaserver+'/oacurrency'
}
//收款列表
export async function receivableList(params) {
    return post(api.payment+'/receivableList', params, true);
}
//详情
export async function receivableDetail(params) {
    return post(api.payment+'/receivableDetail', params, true);
}
//汇票列表
export async function getDraftList(params) {
    return post(api.payment+'/getDraftList', params, true);
}
//应收账款
export async function getAccountsReceivable(params) {
    return post(api.payment+'/getAccountsReceivable', params, true);
}
//保存
export async function savePaymentRec(params) {
    return post(api.payment+'/savePaymentRec', params, true);
}
//作废
export async function receivableCancel(params) {
    return post(api.payment+'/receivableCancel', params, true);
}
//获取币种
export async function getDictList(params) {
    return post(api.oacurrency+'/getDictList', params, true);
}
//公司
export async function getCompanyList(params) {
    return post(api.oacurrency+'/getCompanyList', params, true);
}

//客户
export async function getCustomers(params) {
    return post(api.payment+'/getCustomers', params, true);
}